import React from 'react'
import { Text, Stack  } from '@chakra-ui/react'
import { cuilFormatter } from 'utils/functions/formatString'
import { IDashboardCompany } from 'services/IApi'

interface ICompanySubscriptionResumeProps {
  company: IDashboardCompany
}

// Compania Subscription Resume
const Company = ({ company }: ICompanySubscriptionResumeProps) => (
  <Stack data-testid='company' textAlign='left' borderBottomWidth='1px' borderBottomStyle='solid' borderBottomColor='secondary.80' pb='12px' gap='2px'>
    <Text data-testid='company-name' textStyle={['h6', 'h5Bold']} size={['xs', 'md']} line-height={['2xm', 'lg']} color='tertiary.500'>{company?.name}</Text>
    <Text data-testid='company-cuit' textStyle='titleSm' size='2xs' line-height='md' color='secondary.900'>{company?.document?.type} {cuilFormatter(company?.document?.number)}</Text>
  </Stack>
)

export default Company